












import Vue from 'vue'
import { mapMutations } from 'vuex'

export default Vue.extend({
    computed: {
        mostraConfiniComunali: {
            get(): boolean {
                return this.$store.state.puntiluceMappa.mostraConfiniComunali
            },
            set(value: boolean) {
                this.SET_MOSTRA_CONFINI_COMUNALI(value)
            }
        },
        mostraMappaSatellitare: {
            get(): boolean {
                return this.$store.state.puntiluceMappa.mostraMappaSatellitare
            },
            set(value: boolean) {
                this.SET_MOSTRA_MAPPA_SATELLITARE(value)
            }
        }
    },
    methods: {
        ...mapMutations('puntiluceMappa', ['SET_MOSTRA_CONFINI_COMUNALI', 'SET_MOSTRA_MAPPA_SATELLITARE'])
    }
})
